import { useEffect, useState } from "react";
import { AdminLayout } from "../../components/Layouts";
import { api, readUser, fmt } from "../../lib/api";

export default function AdminAccounts() {
  const user = readUser();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/admins").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <AdminLayout user={user} active="Yönetici Hesapları">
      <section className="admin-panel">
        <div className="admin-panel-title"><div><span className="eyebrow">EKİP</span><h2>Yönetici Hesapları ({rows.length})</h2></div></div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Ad</th><th>E-posta</th><th>Kullanıcı Adı</th><th>Bakiye</th><th>Durum</th></tr></thead>
            <tbody>
              {rows.map((u, i) => (
                <tr key={u.id} data-testid={`admin-admin-${i}`}>
                  <td>{u.full_name}</td>
                  <td>{u.email}</td>
                  <td>@{u.username}</td>
                  <td>${fmt(u.balance)}</td>
                  <td><span className={`status ${u.active ? "confirmed" : "rejected"}`}>{u.active ? "Aktif" : "Pasif"}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="note">Yeni yönetici eklemek için <strong>Kullanıcılar</strong> ekranından ilgili üyenin rolünü <strong>admin</strong> olarak değiştirin.</p>
      </section>
    </AdminLayout>
  );
}
